export default __webpack_public_path__ + "static/media/spread_sheet_ext.9e88926a.png";